<template>
  <Popup :ref="(el) => popup = el"
         :title="$t('labels.payOutDealSla')"
         @onClose="hide"
  >
    <div class="popup__content mb-sm" style="white-space: pre-wrap; word-break: break-word;">
      {{ text }}
    </div>
    <div class="popup__controls">
      <button type="button" @click="hide" class="btn btn--accept">
        <span class="text-capitalize-first">{{ $t('button.close') }}</span>
      </button>
    </div>
  </Popup>
</template>
<script lang="ts">
import {defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";

export default defineComponent({
  components: {Popup},
  setup() {
    const popup = ref<InstanceType<typeof Popup> | null>(null)

    const state = reactive({
      text: '' as string
    });

    const show = (text: string) => {
      state.text = text
      popup.value?.show()
    }

    const hide = () => {
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      popup,
      show,
      hide,
    }
  }
})
</script>
